import styled from "@emotion/styled";
import { Instant } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import FlipClock from "../../FlipClock";

type Props = {
  to: Instant;
};

export default function RaffleCountdown(props: Props) {
  return (
    <FlipClockWrapper>
      <FlipClockLabel>{translate(STRINGS.WINNER_ANNOUNCED_IN)}</FlipClockLabel>
      <FlipClock to={props.to} color="var(--tw-gray-800)" />
    </FlipClockWrapper>
  );
}

const FlipClockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .fcc__label {
    font-size: 14px;
  }
`;

const FlipClockLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin: 12px 0;
  color: var(--tw-gray-800);
`;
